import getLocal from '@/app/utils/getLocal';
import {
    getDiscountCouponList,
    getDiscountCouponListNew1,
    getIssuedCoupons,
    getLevelLogList,
    getRewardHistory,
    getRewardRuleList,
    getRewardsActivity,
    getRewardUserLevel,
} from '@/service/vip';
import { FormatMoney } from '@/utils';
import JoinEcoclub from 'lowcode/OldMember/JoinEcoclubNew';
import GrabEcoCreditsBonus from 'lowcode/OldMember/JoinEcoclubNew/GrabEcoCreditsBonus';
import PointsActivity from 'lowcode/OldMember/JoinEcoclubNew/PointsActivity';
import { useEcoDispatch } from 'lowcode/utils/context/ecocredits';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import FullScreenModal from 'lowcomp/plugins/member/common/FullScreenModal';
import RewardsRedeemed from 'lowcomp/plugins/member/common/RewardsRedeemed';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import { getLang, injectNotes } from 'lowcomp/plugins/member/utils';
import { Fragment, useEffect, useState } from 'react';
import './index.scss';

export default function Content({ loginType = 'page' }: any) {
    const { locale } = getLocal();
    const [isLogin, setIsLogin] = useState(false);
    const [showPage, setShowPage] = useState('basic'); // basic / history_modal / coupon_modal / points_modal / bouns_modal / qhistory_modal / lucky_history
    const ecoDispatch = useEcoDispatch();
    const [issuedCoupon, setIssuedCoupon] = useState<any[]>([]);
    const [pointsActivity, setPointsActivity] = useState([]);
    const [rewardsActivity, setRewardsActivity] = useState([]);
    const [levelLogList, setLevelLogList] = useState<any[]>([]);
    const t = getLang(textLang, locale);
    const { timezoneList } = useMemberTimeStore();

    const openModal = (key: string) => {
        setShowPage(key);
    };

    const closeModal = () => {
        setShowPage('basic');
    };

    useEffect(() => {
        const login = getIsLogin();
        setIsLogin(login);
    }, []);

    /**
     * 查询账户积分详情
     */
    const queryRewardUserInfo = async () => {
        ecoDispatch({
            type: 'changeRewardUserInfo',
            payload: { locale },
        });
    };

    /**
     * 查询账户权益等级
     */
    const queryRewardUserLevel = async () => {
        const ruleRes = await getRewardRuleList(locale as string);
        if (ruleRes?.code !== '0') return;
        const plusMemberData = ruleRes.data.find((item) => item.level === 2);
        const memberData = ruleRes.data.find((item) => item.level === 1);
        const payload = {
            normalName: memberData?.name,
            plusName: plusMemberData?.name,
            minPoint: Number(plusMemberData?.minPoints),
        };

        if (isLogin) {
            const levelRes = await getRewardUserLevel(locale as string);
            // levelRes.data = {
            //     level: 2,
            //     validStartTime: '',
            //     validEndTime: '',
            // };
            if (levelRes?.code === '0' && levelRes.data) {
                const { level, validStartTime, validEndTime } = levelRes.data;
                const userLevelData = ruleRes.data.find((item) => item.level === level);

                Object.assign(payload, {
                    level,
                    validStartTime,
                    validEndTime,
                    name: userLevelData?.name || '',
                });
            }
        }
        ecoDispatch({
            type: 'changeRewardUserLevel',
            payload,
        });
    };

    /**
     * 刷新数据
     */
    const refershData = () => {
        queryRewardUserLevel();
        if (!isLogin) return;
        queryRewardUserInfo();
        // 查询黑名单
        ecoDispatch({
            type: 'checkBlackList',
            payload: { locale },
        });
        //queryRewardEarnRule();
    };

    useEffect(refershData, [isLogin]);

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        let rewardRedeemRules = [];
        const res = await getIssuedCoupons(locale as string);

        if (res?.code === '0') {
            const flatRules = res.data?.map((item: any) => {
                let minimum_rule = '';
                if (item?.prerequisite === 'PRICES') {
                    // 最低金额
                    const price = parseInt(item.prerequisiteRange);
                    const currencySymbol = item?.ruleWebsite?.currencySymbol || '';
                    const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
                    minimum_rule = prerequisiteRange;
                }
                if (item?.prerequisite === 'QUANTITY') {
                    // 最低数量
                    const num = parseInt(item.prerequisiteRange);
                    const prerequisiteRange = t('minimum_num', { num });
                    minimum_rule = prerequisiteRange;
                }
                return {
                    ...item,
                    minimum_rule,
                };
            });

            rewardRedeemRules = injectNotes(flatRules || [], t, locale as string, timezoneList);
            setIssuedCoupon(rewardRedeemRules || []);
        }
    };

    /**
     * 查询查询Rewards Activity 优惠券使用流水
     */
    const queryRewardsActivity = async () => {
        const res = await getRewardsActivity(locale as string);
        if (res?.code === '0') {
            setRewardsActivity(res.data?.content || []);
        }
    };

    /**
     * 福利中心
     */
    const [discountCouponList, setDiscountCouponList] = useState<any[]>([]);
    const [firstIn, setFirstIn] = useState(true);
    const queryDiscountCouponList = async () => {
        const apiRequestFn = !isLogin ? getDiscountCouponListNew1 : getDiscountCouponList;
        const res = await apiRequestFn(locale as string);
        if (res?.code === '0') {
            const coupons = injectNotes(res.data, t, locale as string, timezoneList);
            setDiscountCouponList(coupons || []);
            const isHasUnUsedCoupons = coupons?.some((coupon: any) => coupon?.receiveStatus === 1 || !coupon?.receiveStatus);
            firstIn && isHasUnUsedCoupons && setShowPage('bouns_modal');
            setFirstIn(false);
        }
    };

    /**
     * 用户积分历史记录
     */
    const queryRewardHistory = async (sortType?: number) => {
        const res = await getRewardHistory(locale as string, sortType);
        if (res?.code === '0') {
            setPointsActivity(res.data?.content || []);
        }
    };

    /**
     * 查询查询升级日志
     */
    const queryLevelLogList = async () => {
        const res = await getLevelLogList(locale as string);
        if (res?.code === '0') {
            setLevelLogList(res.data || []);
        }
    };
    return (
        <Fragment>
            <JoinEcoclub isLogin={isLogin} refershData={refershData} openModal={openModal} loginType={loginType} />
            {showPage === 'coupon_modal' && (
                <FullScreenModal
                    visible={showPage === 'coupon_modal'}
                    className={showPage}
                    zIndex={9999}
                    getContainer={() => document.body}
                    style={{ background: '#f8f8f8' }}
                    closeModal={closeModal}
                    afterOpen={() => {
                        queryIssuedRewards();
                    }}
                >
                    <RewardsRedeemed modal defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'} issuedCoupon={issuedCoupon} />
                </FullScreenModal>
            )}
            {showPage === 'history_modal' && (
                <FullScreenModal
                    visible={showPage === 'history_modal'}
                    className={showPage}
                    closeModal={closeModal}
                    afterOpen={() => {
                        queryRewardsActivity();
                        queryRewardHistory();
                        queryLevelLogList();
                    }}
                >
                    <PointsActivity
                        modal
                        pointsActivity={pointsActivity}
                        rewardsActivity={rewardsActivity}
                        levelLogList={levelLogList}
                        locale={locale}
                        handleSortChange={queryRewardHistory}
                    />
                </FullScreenModal>
            )}
            <FullScreenModal
                visible={showPage === 'bouns_modal'}
                zIndex={1200}
                className={`${showPage} top bouns_modal`}
                closeModal={closeModal}
                style={{ background: '#f5f5f5' }}
                afterOpen={() => {
                    queryDiscountCouponList();
                }}
            >
                <GrabEcoCreditsBonus
                    coupons={discountCouponList}
                    setShowPage={setShowPage}
                    isNeedValidate={true}
                    visible={showPage === 'bouns_modal'}
                    refershData={() => {
                        queryIssuedRewards();
                        queryDiscountCouponList();
                    }}
                />
            </FullScreenModal>
        </Fragment>
    );
}
